// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__295Io","list":"BalanceDue_list__3LkCH","listRow":"BalanceDue_listRow__32h_6","total":"BalanceDue_total__1y8HT"};